(() => {
  if (window.HookiiWarehouseOrderPropertyLoaded) return;
  window.HookiiWarehouseOrderPropertyLoaded = true;

  const propertyName = "properties[_仓库中文名称]";
  const names = {};

  document.querySelectorAll("[data-hookii-warehouse-order-names]").forEach((node) => {
    try {
      Object.assign(names, JSON.parse(node.textContent));
    } catch (error) {
      console.error("HOOKII warehouse-name mapping could not be read.", error);
    }
  });

  const nameForForm = (form) => {
    const variantInput = form.querySelector('[name="id"]');
    return variantInput ? names[String(variantInput.value)] || "" : "";
  };

  const syncForm = (form) => {
    if (!(form instanceof HTMLFormElement) || !form.action.includes("/cart/add")) return;
    let input = form.querySelector('input[name="properties[_仓库中文名称]"]');
    const value = nameForForm(form);

    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = propertyName;
      form.appendChild(input);
    }

    input.value = value;
    input.disabled = !value;
  };

  const syncAll = () => {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(syncForm);
  };

  document.addEventListener("formdata", (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.action.includes("/cart/add")) return;
    const value = nameForForm(form);
    if (value) event.formData.set(propertyName, value);
  });

  document.addEventListener("submit", (event) => syncForm(event.target), true);
  document.addEventListener("change", () => queueMicrotask(syncAll), true);
  document.addEventListener("variant:change", () => queueMicrotask(syncAll));
  document.addEventListener("shopify:section:load", syncAll);

  new MutationObserver(syncAll).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", syncAll, { once: true });
  } else {
    syncAll();
  }
})();
